import Popup from '../popup'
import Dom, {getStyle} from '@/utils/dom'
let id = 0

export default {
  props: {
    visible: Boolean,
    onClickCloseModal: {
      type: Boolean,
      default: true
    },
    openDelay: {
      type: [Number, String],
      default: 0
    },
    closeDalay: {
      type: [Number, String],
      default: 0
    },
    modal: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: [Number, String]
    },
    appendToBody: Boolean,
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    visible (val) {
      if (val) {
        if (this._isOpening) return
        if (!this.rendered) {
          this.rendered = true
          this.$nextTick(() => {
            this.open()
          })
        } else {
          this.open()
        }
      } else {
        this.close()
      }
    },
    value (val) {
      if (!val) {
        this.close()
      }
    }
  },
  data () {
    return {
      id: `popup-id-${++id}`,
      opened: false,
      rendered: false,
      openTimer: null,
      closeTimer: null,
      _isOpening: false,
      _isClosing: false,
      withoutHiddenClass: false,
      bodyPaddingRight: false
    }
  },
  beforeMount () {
    Popup.register(this.id, this)
  },
  beforeDestroy () {
    Popup.deregister(this.id)
    Popup.closeModal(this.id)
  },
  methods: {
    open () {
      if (this.$isServer) return
      if (!this.rendered) this.rendered = true
      clearTimeout(this.openTimer)
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
      this.openTimer = setTimeout(() => {
        // willOpne ?
        if (this.opened) return
        this._isOpening = true
        if (this.zIndex) Popup.zIndex = this.zIndex
        const dom = Dom.getDomSkipText(this.$el)
        if (this.modal) {
          if (this._isClosing) {
            Popup.closeModal(this.id)
            this._isClosing = false
          }
          this._isOpening = true
          let nextModalZIndex = Popup.nextZIndex()
          let nextZIndex = Popup.nextZIndex()
          // 保证zIndex比遮罩层高
          dom.style.zIndex = nextZIndex
          Popup.openModal(this.id,
            nextModalZIndex,
            this.appendToBody ? undefined : dom,
            this.modalClass,
            this.modalFade
          )
          this.handleLockScroll(false)
          this.opened = true
          this.doAfterOpen()
        }
      }, Number(this.openDelay))
    },
    close () {
      if (this.openTimer !== null) {
        clearTimeout(this.openTimer)
        this.openTimer = null
      }
      clearTimeout(this.closeTimer)
      this.closeTimer = setTimeout(() => {
        // this.closeTimer = null
        this._isClosing = true
        Popup.closeModal(this.id)
        this.doAfterClose()
      }, Number(this.closeDalay))
    },
    doAfterOpen () {
      this._isOpening = false
      this.opened = true
      this.$emit('on-open')
    },
    doAfterClose () {
      this._isClosing = false
      this.opened = false
      this.handleLockScroll(true)
      this.$emit('input', false)
      this.$emit('on-close')
    },
    handleLockScroll (unlock) {
      if (!this.lockScroll) return
      if (unlock) {
        if (this.modal && this.withoutHiddenClass) {
          document.body.style.paddingRight = this.bodyPaddingRight
          Dom.removeClass(document.body, 'popup-overflow-hidden')
        }
        this.withoutHiddenClass = true
        // TODO 判断是否为移动端
        // scrollLocker.unlock()
      } else {
        let scrollBarWidth = 0
        this.withoutHiddenClass = !Dom.hasClass(document.body, 'popup-overflow-hidden')
        if (this.withoutHiddenClass) {
          this.bodyPaddingRight = document.body.style.paddingRight
          this.computedBodyPaddingRight = parseInt(getStyle(document.body, 'paddingRight'), 10)
        }
        scrollBarWidth = Dom.getScrollBarWidth()
        let bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight
        let bodyOverflowY = getStyle(document.body, 'overflowY')
        if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
          document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px'
        }
        Dom.addClass(document.body, 'popup-overflow-hidden')
        // TODO 判断是否为移动端
        // scrollLocker.lock()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/popup.js